import { render, staticRenderFns } from "./MySelectPortType.vue?vue&type=template&id=136cff46&"
import script from "./MySelectPortType.vue?vue&type=script&lang=js&"
export * from "./MySelectPortType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports